import { Injectable } from '@angular/core';
import { ModalOptions, NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { skip, takeUntil } from 'rxjs/operators';
import { TranslationService } from '.';
import { Unsubscribe } from '../classes';

@Injectable({
  providedIn: 'root',
})
export class GenericModalService extends Unsubscribe {
  translatedTexts = {};

  constructor(
    private modal: NzModalService,
    private translate: TranslationService
  ) {
    super();

    this.translate
      .stream([
        'MESSAGE.GENERIC_WARNING_FORM_MSG',
        'MESSAGE.CANCEL',
        'MESSAGE.CONFIRM',
      ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((translatedTexts) => {
        this.translatedTexts = translatedTexts;
      });
  }

  createModal(config: ModalOptions): NzModalRef {
    const modalRef = this.modal.create(config);

    const containerInstance = modalRef.containerInstance;
    containerInstance.containerClick.pipe(skip(1)).subscribe(() => {
      const cancelable =
        !containerInstance.config.nzCancelLoading &&
        !containerInstance.config.nzOkLoading;
      if (cancelable) {
        modalRef.triggerCancel();
      }
    });
    return modalRef;
  }

  warningFormModal(formGroup, modalInfo, title?, message?) {
    if (formGroup.dirty) {
      new Promise(() => {
        this.modal.confirm({
          nzOkText: this.translatedTexts['MESSAGE.CONFIRM'],
          nzCancelText: this.translatedTexts['MESSAGE.CANCEL'],
          nzTitle: title
            ? title
            : this.translatedTexts['MESSAGE.GENERIC_WARNING_FORM_MSG'],
          nzContent: message ? message : '',
          nzOnOk: () => {
            new Promise(() => {
              this._resetAndCloseForm(formGroup, modalInfo);
            });
          },
        });
      });
      return false;
    } else {
      if (modalInfo) {
        this._resetAndCloseForm(formGroup, modalInfo);
      }
    }
  }

  private _resetAndCloseForm(formGroup, modalInfo) {
    formGroup.reset();
    if (modalInfo.formArrayList) {
      for (let formArray of modalInfo.formArrayList) {
        formArray.clear();
      }
    }
    modalInfo.ref.close();
  }
}
